export default __webpack_public_path__ + "static/logo_sowos_positivo-1d6ef13a1716c6b221e8a9c9a6d2f5aa.svg";